module.exports = __webpack_public_path__ + "static/media/qualityresult.0fce05d5.jpg";